var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "c-nav c-nav--vertical" },
    [
      _c("li", [
        _c(
          "label",
          {
            staticClass: "c-btn c-btn--invisible c-btn--vert-center",
            class: {
              "is-active": _vm.bathroomState.length === 0,
            },
            attrs: { for: "bathrooms-all" },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.bathroomState,
                  expression: "bathroomState",
                },
              ],
              staticClass: "screen-reader-text",
              attrs: { id: "bathrooms-all", type: "radio", name: "bathrooms" },
              domProps: { value: [], checked: _vm._q(_vm.bathroomState, []) },
              on: {
                change: function ($event) {
                  _vm.bathroomState = []
                },
              },
            }),
            _vm._v(" "),
            _c("Toggle", {
              staticClass: "c-btn__icon c-btn__icon--alignment",
              attrs: { isSelected: _vm.bathroomState.length === 0 },
            }),
            _vm._v("\n      Alle\n    "),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.bathrooms, function (bathroom) {
        return _c("li", { key: bathroom.id }, [
          _c(
            "label",
            {
              staticClass: "c-btn c-btn--invisible c-btn--vert-center",
              class: {
                "is-active": _vm.bathroomState.includes(bathroom.name),
              },
              attrs: { for: "bathrooms-" + bathroom.id },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.bathroomState,
                    expression: "bathroomState",
                  },
                ],
                staticClass: "screen-reader-text",
                attrs: {
                  id: "bathrooms-" + bathroom.id,
                  type: "checkbox",
                  name: "bathrooms",
                },
                domProps: {
                  value: bathroom.name,
                  checked: Array.isArray(_vm.bathroomState)
                    ? _vm._i(_vm.bathroomState, bathroom.name) > -1
                    : _vm.bathroomState,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.bathroomState,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = bathroom.name,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.bathroomState = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.bathroomState = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.bathroomState = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("Toggle", {
                staticClass: "c-btn__icon c-btn__icon--alignment",
                attrs: {
                  isSelected:
                    _vm.bathroomState.includes(bathroom.name) === true,
                },
              }),
              _vm._v("\n      " + _vm._s(bathroom.name) + " bad\n    "),
            ],
            1
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }